import { Box, Typography } from '@mui/material';
import { MonthlyStatistics } from '@tassomutuo-backoffice/types';
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import React from 'react';
import { format, parse } from 'date-fns';
import { it } from 'date-fns/locale';

interface IProps {
  statisticsPerMonth: MonthlyStatistics;
  isPrinting?: boolean;
  reverse?: boolean;
}

const DashboardCrTotalLeadsChart = ({
  statisticsPerMonth,
  isPrinting,
  reverse = true,
}: IProps) => {
  const chartData = Object.entries(statisticsPerMonth).map(([month, stats]) => {
    return {
      month,
      crEstimatedMortgagesTotalLeads: stats.crEstimatedMortgagesTotalLeads,
    };
  });

  if (reverse) {
    chartData.reverse();
  }

  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        padding: 4,
        mt: 6,
        borderRadius: '16px',
        border: '1px solid gainsboro',
      }}
    >
      <Typography variant="h4" mb={1} fontWeight="bold">
        Tasso di Conversione Totale
      </Typography>
      <Typography variant="h6" mb={4}>
        Rapporto di conversione tra mutui stimati e lead totali
      </Typography>
      <Box
        sx={{
          width: '100%',
          height: 400,
          p: 2,
          minWidth: isPrinting ? 1000 : undefined,
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <Line
              type="monotone"
              dataKey="crEstimatedMortgagesTotalLeads"
              stroke="rgba(59, 130, 246, 1)"
              strokeWidth={4}
            />
            <CartesianGrid
              stroke="#ccc"
              strokeDasharray="3 3"
              vertical={false}
            />
            <XAxis
              dataKey="month"
              tickFormatter={(month) => {
                const date = parse(month, 'MMMM yyyy', new Date(), {
                  locale: it,
                });
                return format(date, 'MMM yy', { locale: it });
              }}
            />
            <YAxis
              domain={[0, (dataMax: number) => Math.ceil(dataMax * 1.1)]}
            />

            <Tooltip
              formatter={(value) => {
                const formattedValue =
                  typeof value === 'number' ? value.toFixed(2) : value;
                return [`${formattedValue}%`, 'CR Totale'];
              }}
            />
            <Legend
              formatter={(value) => {
                if (value === 'crEstimatedMortgagesTotalLeads') {
                  return 'CR Mutui/Lead Totali';
                }
                return value;
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default DashboardCrTotalLeadsChart;
